export const includesCaseInsensitive = (value: string, reference: string) => reference.toLowerCase().includes(value.toLowerCase())
